<template>
    <b-modal
        id="invitation"
        title="Convidar Alunos"
        hide-footer>

        <p>
            Para adicionar alunos a turma <b>"{{ group.name }}"</b>, eles precisarão utilizar o
            código abaixo para efetuar a matrícula corretamente. Basta o aluno acessar o site e entrar na área
            destinada ao aluno, fazer o cadastro e inserir o código.
        </p>

        <div class="py-3 text-center bg-dark text-light">
            <h3 class="p-0 m-0">
                {{ group.code }}
            </h3>
        </div>

    </b-modal>
</template>

<script>
export default {
    props: ['endpoint'],
    data() {
        return {
            loading: false,
            id: null,
            group: {
                name: null,
                code: null
            }
        }
    },
    created() {
        this.$root.$on('invitationGroup', (event) => {

            // Set Form
            this.group = event

            // Modal
            this.$bvModal.show('invitation')

        })
    },
}
</script>

<style scoped>

</style>
